<template>

<div>
    <v-flex xs12 sm10 offset-sm1>

        <Alert v-if="alertType !== ''" :atype="alertType" :message="alertMessage" :visibility="visibility" />

        <v-progress-linear v-if="progressbar" :indeterminate="true"></v-progress-linear>

        <!--Bank selection-->
        <v-item-group>

            <v-container grid-list-lg>

                <v-layout wrap>

                    <v-flex v-for="(bank,index) in banks" :key="index" xs6>

                        <v-item>

                            <v-hover>

                                <v-card slot-scope="{ hover }" class="mx-auto" color="grey lighten-4" max-width="800" @click.prevent='showAddBankForm(bank)'>

                                    <v-img :aspect-ratio="300/100" :src="bank.logo_url">

                                        <v-expand-transition>

                                            <div v-if="hover" class="d-flex transition-fast-in-fast-out grey darken-2 v-card--reveal display-3 text-xs-center" style="height: 100%;">
                                                {{bank.name}}
                                            </div>

                                        </v-expand-transition>

                                    </v-img>

                                </v-card>

                            </v-hover>

                        </v-item>

                    </v-flex>

                </v-layout>

            </v-container>

        </v-item-group>

        <!--Dialog and Form-->
        <showDialog :status="dialog" :selectedBank="data.selectedBank" @DialogAddBankSave="save" @DialogClose="close" />

        <!--Snackbar-->
        <snackbar :show="snackbar" :color="'green'" :text="$t( 'withdraw.bank_add_success' )" :icon="'done_all'"/>

    </v-flex>
</div>
</template>

<script>
import snackbar from '@/components/Reusable/Snackbar.vue';
import showDialog from '@/components/Withdrawal/Dialog.vue';
import Alert from "@/components/Reusable/Alert.vue";
import Api from "@/api";

export default {
    data() {
        return {
            valid: true,
            data: {
                selectedBank: null
            },
            banks: [],
            dialog: false,
            alertType: "",
            alertMessage: "",
            visibility: false,
            progressbar: false,
            snackbar: false,
            message: "",
            color: ""
        }
    },
    components: {
        Alert,
        snackbar,
        showDialog
    },
    mounted() {

        this.getBanks();
    },
    watch: {
        'message': function(message) {
            let currentInstance = this;
            setTimeout(function() {
                currentInstance.snackbar = false;
                if (message == "Add Bank Account Successfully") {
                    return currentInstance.$router.push({
                        name: 'Banklist'
                    });
                }
            } , 1000);
        }
    },
    methods: {
        getImgUrl(img) {

            var images = require.context('@/assets/', false, /\.png$/);

            return images('./' + img + ".png");

        },
        save(response) {

            this.message = response.message;

            this.color = "green";

            this.dialog = response.dialog;

            this.snackbar = true;

        },
        close() {

            this.data.selectedBank = null;

            this.dialog = !this.dialog;

        },
        async getBanks() {

            let res = await Api.getBanks({
                access_token: this.$store.getters.user_token
            });

            if (res && 'success' in res && res.success === true) {

                this.banks = res.data;

            } else {

                this.visibility = true;

                this.alertMessage = res.message;

                this.alertType = "error";

                if(res.message == "token invalid") {

                    this.$store.dispatch('logout', res.data);

                    this.$router.push({name: 'login'})

                }

            }

        },
        showAddBankForm(bank) {

            this.dialog = !this.dialog;

            this.data.selectedBank = bank;

            return;

        }

    }

}
</script>

<style>
    .v-card--reveal {
        align-items: center;
        bottom: 0;
        justify-content: center;
        opacity: .5;
        position: absolute;
        width: 100%;
    }
</style>
